
const AiPromptRoutes = [
    {
        path: '',
        name: 'ai-prompt-index',
        component: () => import("@/components/admin/prompt/list.vue"),
    },
    {
        path: 'list',
        name: 'list-ai-prompt',
        component: () => import("@/components/admin/prompt/list.vue"),
    },
    {
        path: 'form',
        name: 'form-ai-prompt',
        component: () => import("@/components/admin/prompt/form.vue"),
    }
];
export default AiPromptRoutes
